import * as React from "react";

interface IProps {
  size: number;
  color?: string;
}
const ServerError: React.FC<IProps> = ({ size, color = undefined }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 107 107"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.828 106.828l104-104L104 0 0 104l2.828 2.828zM7.414 3.414H94.93l-4 4H7.414a2 2 0 00-2 2v20a2 2 0 002 2H66.93l-4 4H7.414a6 6 0 01-6-6v-20a6 6 0 016-6zM99.414 31.414H83.9l-4 4h19.514a6 6 0 006-6V9.9l-4 4v15.514a2 2 0 01-2 2zM60.93 37.414H7.413a6 6 0 00-6 6v20a6 6 0 006 6H28.93l4-4H7.414a2 2 0 01-2-2v-20a2 2 0 012-2H56.93l4-4zM77.9 37.414l-4 4h25.514a2 2 0 012 2v20a2 2 0 01-2 2H49.9l-4 4h53.514a6 6 0 006-6v-20a6 6 0 00-6-6H77.9zM26.93 71.414H7.413a6 6 0 00-6 6V96.93l4-4V77.414a2 2 0 012-2H22.93l4-4zM43.9 71.414l-4 4h59.514a2 2 0 012 2v20a2 2 0 01-2 2H15.9l-4 4h87.514a6 6 0 006-6v-20a6 6 0 00-6-6H43.9z"
        fill={color}
      />
      <path
        d="M25.414 89.9l4-4v7.514h-4V89.9zM13.414 81.414v3.515l-4 4v-7.515h4zM9.414 25.414v-12h4v12h-4zM17.414 25.414v-12h4v12h-4zM25.414 13.414v12h4v-12h-4zM9.414 47.414v12h4v-12h-4zM17.414 59.414v-12h4v12h-4zM25.414 47.414v12h4v-12h-4z"
        fill={color}
      />
    </svg>
  );
};

export default ServerError;
